export const getHeightWithProportion = (w, w2, h) => h * (w / w2).toFixed(3);
